const APPLICATION_REVIEW = { code: "APP", description: "Application Review" };
const CERTIFICATION_REVIEW = { code: "CER", description: "Certification Review" };
const SITE_REVIEW = { code: "STR", description: "Site Review" };
const FINAL_REVIEW = { code: "FIN", description: "Final Review" };
const COMMITTEE_REVIEW = { code: "COM", description: "Committee Review" };

export default {
    APPLICATION_REVIEW,
    CERTIFICATION_REVIEW,
    SITE_REVIEW,
    FINAL_REVIEW,
    COMMITTEE_REVIEW
};


// WEBPACK FOOTER //
// ./src/areas/shared/consts/QueueType.js